import { hasCapability, type User } from "../base";

export const actionable = {
  read: (user: User) => hasCapability(user, "actionable.read"),
};
